// extracted by mini-css-extract-plugin
export default {"recording_container":"CameraRecordings_recording_container__l-+gn"};